import { render, staticRenderFns } from "./NestedRoutes.vue?vue&type=template&id=3feff572&"
import script from "./NestedRoutes.vue?vue&type=script&lang=js&"
export * from "./NestedRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports